import axios from 'axios';
import {getJwtToken} from '../services/jwt.services';
const BASE_URL = process.env.REACT_APP_BASE_URL;
class NewsLetterServiceController {
  async getdistributions(companyid) {
    
    if (companyid === 'undefined' || companyid === '')
    {
      companyid="REQUIRED";
      return { status: 'ERROR', data: "No Company" };
    }
    const jwtToken = getJwtToken();
    try {
    
      const apiUrl = `${BASE_URL}/newsletters/${companyid}`;
      const headers = {
        'Authorization': `Bearer ${jwtToken}`,
        'Content-Type': 'application/json', // Adjust the content type if needed
      };
      const result = await axios.get(apiUrl, {headers});
      const status = { status:"ok",data:  result.data};
      console.log('resrut', status);
      return status;
    } catch (_e) {
      const status = [{ data: {companyid: companyid, status: 'Error',  reason: `User not valid for company ${companyid}`} }];
      
      return {"status":"fail", data: status}
      //return [];
    }
  }
}

export const NewsLetterService = new NewsLetterServiceController();